import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'; 
import { map, Observable } from 'rxjs';
import { ControllerApiPath } from '../services/constant';
import { Teams } from '../model/Teams';
import { SharedServiceService } from '../services/shared-service.service';
 

@Injectable({
  providedIn: 'root'
})
export class TeamService {
  private apiBaseUrl:string;
  constructor(private http: HttpClient,private sharedService: SharedServiceService) {
    this.apiBaseUrl = sharedService.baseUrl();
   }
  
  getEnneagramType():Observable<any>{
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.teams+'/GetEnneagramType';    
    return this.http.get(url,{ headers });
  }

  getDiabetesType():Observable<any>{
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.teams+'/GetDiabetesType';    
    return this.http.get(url,{ headers });
  }

  addTeam(team: Teams){
    const headers = this.sharedService.createAuthorizationHeader();
    return this.http.post<Teams>(this.apiBaseUrl+ControllerApiPath.teams, team, { headers }).pipe(
      map((team: Teams) => {
       // console.log(Team);
        return team;
      })
    )
  }

  getAllTeam():Observable<any>{
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.teams;    
    return this.http.get(url,{ headers });
  }

  getTeamById(id: any) {
    const headers = this.sharedService.createAuthorizationHeader();
    const url = this.apiBaseUrl + ControllerApiPath.teams+'/GetTeam?teamId='+id;
    return this.http.get<Teams>(url,{ headers }).pipe(
      map((Team: Teams) => {
        return Team;
      })
    );
  }

  updateTeam(team:Teams,id:any){
    const headers = this.sharedService.createAuthorizationHeader();
    return  this.http.put<Teams>(this.apiBaseUrl + ControllerApiPath.teams, team, { headers })
  }

  assignTeam(team:any){
    const headers = this.sharedService.createAuthorizationHeader();
    return  this.http.post(this.apiBaseUrl + ControllerApiPath.members+'/AssignTeam', team, { headers })
  }

  deleteTeam(id:any){
    const headers = this.sharedService.createAuthorizationHeader();
    return this.http.delete<Teams>(this.apiBaseUrl + ControllerApiPath.teams +'?teamId='+id, { headers })
  }
  getLoggedUser(){
    return this.sharedService.getLoggedInUser();
  }

  searchTeam(data:any){
    const headers = this.sharedService.createAuthorizationHeader();
    return  this.http.get<Teams>(this.apiBaseUrl + ControllerApiPath.teams+'/SearchTeam?teamname='+data+'&pagesize=25&pagenumber=1', { headers })
    
  }
}
